<template>
    <section id="cp-request">
        <b-modal
                id="cp-request-popup"
                @hide="onHide"
                ref="cpReqMod"
                hide-header
                hide-footer
                centered>
            <CpRequest :hide-modal="hide"/>
        </b-modal>
    </section>
</template>

<script>
    import CpRequest from "./index";
    export default {
        name: 'CpRequestModal',
        components: {
            CpRequest
        },
        mounted: function () {
            this.$bvModal.show(`cp-request-popup`)
        },
        methods: {
            hide: function () {
                this.$bvModal.hide('cp-request-popup')
                setTimeout(() => {
                    this.$store.commit('TOGGLE_MODAL', ['cp-request', false])
                }, 0)
            },
            onHide: function (evt) {
                const query = {...this.$route.query}
                delete query.project_id
                delete query.counterOffer
                delete query.oldRequestDate
                this.$router.replace({
                    query
                }).catch(() => {})

                setTimeout(() => {
                    this.$store.commit('TOGGLE_MODAL', ['cp-request', false])
                }, 0)
            },
        },
    }
</script>
